import axios from "axios";

const API_URL = "/api/config";

let _environment = null;

// #17 - which environment the API runs in, and whether it actually transmits
// outbound third-party calls. Cached after the first fetch.
export async function fetchEnvironment() {
  if (_environment) {
    return _environment;
  }
  const response = await axios.get(`${API_URL}/environment`);
  _environment = response.data;
  return _environment;
}

const ConfigService = {
  fetchEnvironment,
};

export default ConfigService;
